import { Observable } from 'rxjs';
import { UpdateMerchantRequest } from '@app/data/dtos/tpv/merchant-update.dto';

/**
 * Port abstracto para el ciclo de vida de un comercio en el TPV (escritura) — §3.
 * Permiso backend: IsAdmin. Estos endpoints NO llevan `Idempotency-Key` obligatoria.
 *
 * `externalIdMerchant` es el UUID del comercio (external_id_merchant).
 */
export abstract class MerchantLifecycleRepository {
  /** Edición parcial: al menos un bloque (merchant/address/contact_person/bank). */
  abstract updateMerchant(
    externalIdMerchant: string,
    payload: UpdateMerchantRequest,
  ): Observable<void>;

  /** Soft-delete reversible → INACTIVE. */
  abstract deleteMerchant(externalIdMerchant: string): Observable<void>;

  /**
   * Activación: registra el comercio en Memphis y devuelve el payload del back
   * (puede traer `token_activation`, necesario para activar la app del POS).
   * Null si el back no devuelve cuerpo.
   */
  abstract activateMerchant(externalIdMerchant: string): Observable<Record<string, unknown> | null>;
}
